import { Dispatch } from 'redux'
import { DEFAULT_SENDER_RECOGNITIONS, SenderRecognitions } from 'data/senderRecognitions'
import { getSenderRecognitions } from 'util/server/mainApi'

type SetSenderRecognitionsDispatch = Dispatch<{
  type: 'SET_SENDER_RECOGNITIONS'
  senderRecognitions: SenderRecognitions
}>

export function fetchSenderRecognitions() {
  return async (dispatch: SetSenderRecognitionsDispatch) => {
    return getSenderRecognitions().then((resp) => {
      if (resp.data?.senderRecognitions) {
        return dispatch({ type: 'SET_SENDER_RECOGNITIONS', senderRecognitions: resp.data.senderRecognitions })
      }

      return dispatch({ type: 'SET_SENDER_RECOGNITIONS', senderRecognitions: DEFAULT_SENDER_RECOGNITIONS })
    })
  }
}
